export const getProductTag = (product: string[]): { label: string }[] => {
  if (!product || !product.length) {
    return [];
  }

  let firstProduct = product[0];

  if (firstProduct === 'jira-core') {
    firstProduct = 'jira';
  }

  if (firstProduct === 'atlassian-guard') {
    firstProduct = 'guard';
  }

  return [{ label: product.length > 1 ? 'Multiple products' : firstProduct.replaceAll('-', ' ') }];
};

export const formatDurationFromMinutes = (totalMinutes: number): string => {
  if (totalMinutes > 59) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (minutes === 0) {
      return `${hours} h`;
    }

    return `${hours} h ${minutes} min`;
  }

  return `${totalMinutes} min`;
};
